var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBottomArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 7,
    viewBox: "0 0 21 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1666 1.04691L11.1322 5.94691C11.0483 5.99247 10.9486 6.02861 10.839 6.05327C10.7293 6.07793 10.6117 6.09062 10.493 6.09062C10.3743 6.09062 10.2567 6.07793 10.147 6.05327C10.0374 6.02861 9.93773 5.99247 9.85382 5.94691L0.819445 1.04691C0.649924 0.954965 0.554688 0.830262 0.554688 0.700233C0.554688 0.570205 0.649924 0.445502 0.819445 0.353558C0.988967 0.261614 1.21889 0.209961 1.45863 0.209961C1.69837 0.209961 1.92829 0.261614 2.09781 0.353558L10.493 4.9075L18.8882 0.353558C18.9721 0.308032 19.0718 0.271919 19.1815 0.24728C19.2911 0.222642 19.4087 0.209961 19.5274 0.209961C19.6461 0.209961 19.7636 0.222642 19.8733 0.24728C19.983 0.271919 20.0826 0.308032 20.1666 0.353558C20.2505 0.399084 20.3171 0.453132 20.3625 0.512614C20.4079 0.572097 20.4313 0.63585 20.4313 0.700233C20.4313 0.764617 20.4079 0.82837 20.3625 0.887853C20.3171 0.947335 20.2505 1.00138 20.1666 1.04691Z",
    fill: "#777777"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomArrow);
export default __webpack_public_path__ + "static/media/bottom-arrow.65847d85010bdbba634214f879f3b058.svg";
export { ForwardRef as ReactComponent };